// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionRulesMaybe_root__3cTZM","title":"SectionRulesMaybe_title__26lwt","rules":"SectionRulesMaybe_rules__3zT4R"};